/* eslint-disable max-len */
import {
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined,
} from '@ant-design/icons';
import { faListOl, faListUl, faStrikethrough, faSubscript, faSuperscript } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { images } from '../appCore';

export const APP_CURRENT_VERSION = '1.0.38';
export const DOMAIN = '_hostOrigin';
export const MAX_MEMORY_STACK_USER_SETTING = 100;
export const DEFAULT_LIMIT_ITEM_PER_PAGE = 10;
export const FETCH_THUMBNAIL_IMAGE_TIMEOUT = 60000;
export const APP_NAME = 'MOCKY';
export const DISABLED_CATEGORYS = ['UML'];
export const AUTO = 'auto';
export const MANUAL = 'manual';
export const TEXT_GROUP_ID = 'text_custom_group';
export const CUSTOM_GROUP_ID = 'user_custom_group';
export const NUMBER_OF_DASHS_OF_SUB_CATE_ID = 3;
export const BORDER_SCALE_FACTOR = 3;
export const MINIMUM_SIZE_SCALING = 1;
export const CORNER_SIZE = 8;
export const CORNER_COLOR = '#007AFF';
export const CORNER_STROKE_WIDTH = 1;
export const SUBTYPE_TEXT_COMPONENT = 'text_component';
export const SUBTYPE_ICON = 'icon';
export const ACTIVE_SELECTION_ID = 'active_selection';
export const BORDER_LINE_ID = 'borderLine';
export const OVER_LINE_ID = 'overLine';
export const IMAGE_HTML_ID = 'img_html';
export const IMAGE_ID = 'img';
export const GROUP = 'group';
export const TEXTBOX = 'textbox';
export const ITEXT = 'i-text';
export const TEXT = 'text';
export const CUSTOM_TEXT = 'customText';
export const TEXT_COMPONENT = 'textComponent';
export const TEXT_AREA = 'Text area';
export const PATH = 'path';
export const CIRCLE = 'circle';
export const ACTIVE_SELECTION = 'activeSelection';
export const IMAGE = 'image';
export const RECT = 'rect';
export const TRIANGLE = 'triangle';
export const HEADER_CONTAINER = 'header container';
export const TITLE_CONTAINER = 'title container';
export const CHILDREN_PAGE = 'children';
export const SIBLING_PAGE = 'sibling';
export const DOWN = 'down';
export const RIGHT = 'right';
export const LEFT = 'left';
export const UP = 'up';
export const TOP = 'top';
export const BOTTOM = 'bottom';
export const CHART = 'chart';
export const VISUAL_LIST_TYPE = {
  WORKFLOW: 'workflow',
  GRID: 'grid',
  MAP: 'map',
};
export const IMAGE_HTML_TYPE = {
  table: 'table',
  radiusCheck: 'radius_check',
  boxCheck: 'box_check',
  bulletList: 'bullet_list',
  linkBar: 'link_bar',
  breadcrumb: 'breadcrumb',
  treeList: 'tree_list',
  stepNav: 'step_nav',
  rating: 'rating',
  calendar: 'calendar',
  menuBar: 'menu_bar',

  chart: 'chart',
};
export const WORKFLOW_STATUS = {
  default: 0,
};
export const REVISION_HISTORY_TYPE = {
  auto: 0,
  manual: 1,
};
export const FABRIC_COMPONENT_TYPE = {
  [GROUP]: GROUP,
  [TEXTBOX]: TEXTBOX,
  [ITEXT]: ITEXT,
  [TEXT]: TEXT,
  [ACTIVE_SELECTION]: ACTIVE_SELECTION,
  [IMAGE]: IMAGE,
  [RECT]: RECT,
};
export const FABRIC_CUSTOM_OBJECT = {
  textRectWithText: 'Text RectWithText',
  textRectTextSVG: 'Text RectTextSVG',
  iconRectTextSVG: 'Icon RectTextSVG',
  rectScrollBar: 'Rect ScrollBar',
  triangleScrollBar: 'Triangle ScrollBar',
  circleSlider: 'Circle Slider',
  slider: 'Slider',
  audioVideo: 'AudioVideo',
  checkBoxRadio: 'CheckBoxRadio',
  scrollBar: 'ScrollBar',
  customImage: 'CustomImage',
  rectWithText: 'RectWithText',
  rectTextSVG: 'RectTextSVG',
  pathArrow: 'Path Arrow',
  arrowLine: 'Arrow Line',
  modifiableArrowLine: 'Modifiable Arrow Line',
  line: 'Line',
  polyline: 'polyline',
  label: 'Label',
  brackets: 'Brackets',
  swimLaneVertical: 'SwimLaneVertical',
  swimLaneHorizontal: 'SwimLaneHorizontal',
  verticalLine: 'Vertical Line',
  horizontalLine: 'Horizontal Line',
  uml: {
    class: 'Class',
    activeClass: 'ActiveClass',
    interface: 'Interface',
    package: 'Package',
    entityWithKey: 'EntityWithKey',
    entityWithKeyAndType: 'EntityWithKeyAndType',
    component: 'Component',
    componentBox: 'ComponentBox',
    optionLoop: 'OptionLoop',
    alternative: 'Alternative',
    note: 'Note',
    node: 'Node',
    constraint: 'Constraint',
    multiplicity: 'Multiplicity',
    useCaseWithExtensionPoint: 'UseCaseWithExtensionPoint',
    signal: 'Signal',
    offPage: 'OffPage',
    weakComponent: {
      weakEntity: 'WeakEntity',
      weakRelationship: 'WeakRelationship',
      multivaluedAttribute: 'MultivaluedAttribute',
      entity: 'Entity',
      relationship: 'Relationship',
      attribute: 'Attribute',
    },
    notWithText: 'NotWithText',
    outsideText: 'OutsideText',
  },
};
export const OBJECT_NOT_EFFECTED_BY_GRID_MOVING_STEP = [
  'Path Arrow',
  'Arrow Line',
  'Modifiable Arrow Line',
  'Line',
  'Slider',
];
export const NOTIFICATION_KEY = 'notification';
export const PAGE_TYPE = 'page';
export const FOLDER_TYPE = 'folder';
export const MAIN_MENU = {
  elements: {
    icon: images.BLOCK,
    text: 'UI Elements',
    key: 'elements',
    componentType: 'systemList',
  },
  diagrams: {
    icon: images.DIAGRAM,
    text: 'Diagrams',
    key: 'diagrams',
    componentType: 'diagramList',
  },
  icons: {
    icon: images.ICONSUI,
    text: 'Icons',
    key: 'icons',
    componentType: 'iconList',
  },
};

export const CATEGORY_TYPE = {
  SYSTEM: 'systemCategories',
  DIAGRAM: 'diagramCategories',
  ICON: 'iconCategories',
};

export const CANVAS_DEFAULT_SIZE = {
  getWidth: () => {
    const canvasViewElement = document.getElementById('canvas-view');
    return canvasViewElement?.offsetWidth || 1920;
  },
  getHeight: () => {
    const canvasViewElement = document.getElementById('canvas-view');
    return canvasViewElement?.offsetHeight || 1080;
  },
};

export const DEFAULT_MARGIN_OF_PAGE = 120;
export const newDefaultPage = (key, title) => ({
  key,
  title,
  type: PAGE_TYPE,
  children: [],
});
export const newDefaultFolder = (key, title) => ({
  key,
  title,
  type: FOLDER_TYPE,
  children: [],
});
export const DEFAULT_PAGE_DIMENSION = {
  left: 0,
  top: 0,
  width: CANVAS_DEFAULT_SIZE.getWidth(),
  height: CANVAS_DEFAULT_SIZE.getHeight(),
  background: '#fff',
};

export const TEXT_SETTINGS = [
  { action: 'fill', type: 'color', text: 'Outline' },
  { action: 'textBackgroundColor', type: 'color', text: 'Backgroud' },
  {
    action: 'opacity',
    type: 'range',
    text: 'Opacity',
    min: '0',
    max: '1',
    step: '0.1',
  },
  {
    action: 'lineHeight',
    type: 'range',
    text: 'Line height',
    min: '0',
    max: '10',
    step: '1',
  },
  {
    type: 'group-button',
    list: [
      {
        action: 'fontWeight',
        value: 'bold',
        type: 'button',
        icon: <BoldOutlined style={{ fontWeight: 'bold', fontSize: '13px' }} />,
      },
      {
        action: 'underline',
        type: 'button',
        value: true,
        icon: <UnderlineOutlined style={{ fontWeight: 'bold', fontSize: '13px' }} />,
      },
      {
        action: 'fontStyle',
        type: 'button',
        value: 'italic',
        icon: <ItalicOutlined style={{ fontWeight: 'bold', fontSize: '13px' }} />,
      },
    ],
  },
  {
    action: 'textAlign',
    type: 'group-button',
    list: [
      {
        action: 'textAlign',
        type: 'button',
        value: 'left',
        icon: <AlignLeftOutlined />,
        tooltipLabel: 'Align Left',
      },
      {
        action: 'textAlign',
        type: 'button',
        value: 'center',
        icon: <AlignCenterOutlined />,
        tooltipLabel: 'Align Center',
      },
      {
        action: 'textAlign',
        type: 'button',
        value: 'right',
        icon: <AlignRightOutlined />,
        tooltipLabel: 'Align Right',
      },
      {
        action: 'textAlign',
        type: 'button',
        value: 'top',
        icon: <VerticalAlignTopOutlined />,
        tooltipLabel: 'Align Top',
      },
      {
        action: 'textAlign',
        type: 'button',
        value: 'middle',
        icon: <VerticalAlignMiddleOutlined />,
        tooltipLabel: 'Align Middle',
      },
      {
        action: 'textAlign',
        type: 'button',
        value: 'bottom',
        icon: <VerticalAlignBottomOutlined />,
        tooltipLabel: 'Align Bottom',
      },
    ],
  },
  {
    type: 'number',
    action: 'fontSize',
    text: 'Size(px)',
    min: '6',
    max: '96',
    step: '1',
  },
  {
    type: 'select',
    action: 'fontFamily',
    text: 'Fonts',
    options: [],
  },
];

export const SHAPE_SETTINGS = [
  { action: 'fill', type: 'color', text: 'Fill' },
  { action: 'stroke', type: 'color', text: 'Stroke' },
  {
    action: 'opacity',
    type: 'range',
    text: 'Opacity',
    min: '0',
    max: '1',
    step: '0.1',
  },
];

export const GROUP_SETTINGS = [
  {
    action: 'opacity',
    type: 'range',
    text: 'Opacity',
    min: '0',
    max: '1',
    step: '0.1',
  },
];

export const ZOOM_LEVEL = [25, 50, 100, 125, 150, 175, 200, 250];
export const ZOOM_LIMIT = {
  MIN: 0.1,
  MAX: 5,
};

export const BRUSH_MODE = [
  {
    value: 'Pencil',
    label: 'Pencil',
  },
  {
    value: 'Circle',
    label: 'Circle',
  },
  {
    value: 'Spray',
    label: 'Spray',
  },
  {
    value: 'vline',
    label: 'V-Line',
  },
  {
    value: 'hline',
    label: 'H-Line',
  },
  {
    value: 'square',
    label: 'Square',
  },
  {
    value: 'diamond',
    label: 'Diamond',
  },
];

export const DRAWING_TOOLS = [
  {
    action: 'mode',
    type: 'select',
    label: 'Mode',
  },
  {
    action: 'lineWidth',
    type: 'range',
    min: '1',
    max: '20',
    step: '1',
    label: 'Line width',
  },
  {
    action: 'lineColor',
    type: 'color',
    label: 'Line Color',
  },
  {
    action: 'shadowWidth',
    type: 'range',
    min: '0',
    max: '20',
    step: '1',
    label: 'Shadow width',
  },
  {
    action: 'shadowColor',
    type: 'color',
    label: 'Shadow Color',
  },
  {
    action: 'shadowOffset',
    type: 'range',
    min: '0',
    max: '50',
    step: '1',
    label: 'Shadow offset',
  },
];

export const KEYS_CODE = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  DELETE: 46,
  ESCAPE: 27,
  ALT: 18,
  OPTION: 18,
  SPACE: 32,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  I: 73,
  K: 75,
  M: 77,
  R: 82,
  S: 83,
  U: 85,
  V: 86,
  X: 88,
  Y: 89,
  Z: 90,
};

export const DEFAULT_BRUSH = {
  mode: 'Pencil',
  lineWidth: 1,
  lineColor: '#000',
  shadowWidth: 0,
  shadowColor: '#000',
  shadowOffset: 0,
};

export const FONT_SIZE = [6, 8, 9, 10, 11, 12, 14, 18, 24, 30, 36];
export const DASH_ARRAY = [
  { id: 0, strokeDashArray: [0, 0], strokeLineCap: 'butt' },
  { id: 1, strokeDashArray: [12, 3], strokeLineCap: 'butt' },
  { id: 2, strokeDashArray: [26, 16], strokeLineCap: 'butt' },
  { id: 3, strokeDashArray: [3, 10, 12, 10], strokeLineCap: 'butt' },
  { id: 4, strokeDashArray: [10, 2, 1, 2, 1, 2], strokeLineCap: 'butt' },
  { id: 5, strokeDashArray: [8, 10, 26, 10], strokeLineCap: 'butt' },
  { id: 6, strokeDashArray: [3, 3], strokeLineCap: 'butt' },
  { id: 7, strokeDashArray: [5, 5], strokeLineCap: 'butt' },
  { id: 8, strokeDashArray: [0, 5], strokeLineCap: 'round' },
  { id: 9, strokeDashArray: [0, 3], strokeLineCap: 'round' },
];
// offset is distance between last point of line with port
// Position is the distance between (arrow head or tail count by center of its) with the last point of the line
// multiply by 2/5
export const ARROW_HEAD_TYPE = [
  {
    id: 1,
    icon: (
      <svg style={{ width: '32px', height: '14px', fill: '#787878', stroke: '#787878', strokeWidth: '1.5px' }}>
        <path d="M 0 7 L 30 7" />
      </svg>
    ),
    path: '',
    position: 0,
    offset: 0,
  },
  {
    id: 2,
    icon: (
      <svg style={{ width: '32px', height: '14px', fill: '#787878', stroke: '#787878', strokeWidth: '1.5px' }}>
        <path d="M 0 7 L 20 7 L 20 12 L 30 7 L 20 2 L 20 7 Z" />
      </svg>
    ),
    path: 'M 0 0 L 4 2 L 0 4 Z',
    position: 4,
    offset: 4,
    isSolid: true,
  },
  {
    id: 3,
    icon: (
      <svg style={{ fill: '#fff', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '14px' }}>
        <path d="M 0 7 L 20 7 L 20 12 L 30 7 L 20 2 L 20 7 Z" />
      </svg>
    ),
    path: 'M 0 0 L 4 2 L 0 4 Z',
    position: 4,
    offset: 4,
    hasStroke: true,
    isTriangle: true,
  },
  {
    id: 4,
    icon: (
      <svg style={{ fill: '#787878', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '14px' }}>
        <path d="M 0 7 L 20 7 L 20 12 L 30 12 L 30 2 L 20 2 L 20 7 Z" />
      </svg>
    ),
    isSolid: true,
    path: 'M 0 0 L 4 0 L 4 4 L 0 4 Z',
    position: 4,
    offset: 4,
  },
  {
    id: 5,
    icon: (
      <svg style={{ fill: 'none', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '14px' }}>
        <path d="M 0 7 L 20 7 L 20 12 L 30 12 L 30 2 L 20 2 L 20 7 Z" />
      </svg>
    ),
    path: 'M 0 0 L 4 0 L 4 4 L 0 4 Z',
    position: 4,
    offset: 4,
    hasStroke: true,
    isRectangle: true,
  },
  {
    id: 6,
    icon: (
      <svg style={{ fill: 'none', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '14px' }}>
        <path d="M 0 7 L 30 7 M 19 2 L 29 12 M 29 2 L 19 12" />
      </svg>
    ),
    path: 'M 0 0 L 8 8 M 8 0 L 0 8', // multiply by 4/5
    position: 8.25,
    offset: 0.1,
  },
  {
    id: 7,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 30 7 M 20 12 L 30 7 L 20 2" />
      </svg>
    ),
    path: 'M 0 0 L 4 2 L 0 4',
    position: 4,
    offset: 0.5,
    fill: 'none',
    hasStroke: true,
    isTriangle: true,
  },
  {
    id: 8,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 20 7" />
        <path d="M 25.5,1.5 A 5.5,5.5 0 1 1 25.499,1.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 1 1.9996,0',
    position: 4,
    offset: 3.6,
    isSolid: true,
  },
  {
    id: 9,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 20 7" />
        <path d="M 25.5,1.5 A 5.5,5.5 0 1 1 25.499,1.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 1 1.9996,0',
    position: 4,
    hasStroke: true,
    offset: 3.9,
  },
  {
    id: 10,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 25 7" />
        <path d="M 30.5,1.5 A 5.5,5.5 0 1 0 30.5,12.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 0 2,4',
    position: 2,
    offset: 1.7,
    isSolid: true,
  },
  {
    id: 11,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 25 7" />
        <path d="M 30.5,1.5 A 5.5,5.5 0 1 0 30.5,12.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 0 2,4',
    position: 1.8,
    offset: 1.7,
    hasStroke: true,
  },
  {
    id: 12,
    icon: (
      <svg style={{ fill: '#787878', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '16px' }}>
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 15.07106781 L 30 8 L 22.92893219 0.92893219 L 15.8578644 8 Z" />
      </svg>
    ),
    isSolid: true,
    path: 'M 2.82842712 0 L 5.65685425 2.82842712 L 2.82842712 5.65685425 L 0 2.82842712 Z',
    position: 5.65685425,
    offset: 5,
  },
  {
    id: 13,
    icon: (
      <svg style={{ fill: 'none', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '16px' }}>
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 15.07106781 L 30 8 L 22.92893219 0.92893219 L 15.8578644 8 Z" />
      </svg>
    ),
    path: 'M 2.82842712 0 L 5.65685425 2.82842712 L 2.82842712 5.65685425 L 0 2.82842712 Z',
    position: 5.65685425,
    offset: 5,
    hasStroke: true,
  },
  {
    id: 14,
    icon: (
      <svg style={{ fill: '#787878', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '16px' }}>
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 12.08248290464 L 30 8 L 22.92893219  3.91751709536 L 15.8578644 8 Z" />
      </svg>
    ),
    isSolid: true,
    path: 'M 0 1.632993161856 L 2.828427124 3.265986326912 L 5.6568542488 1.632993161856 L 2.828427124 0 Z',
    position: 5.65685425,
    offset: 4.8,
  },
  {
    id: 15,
    icon: (
      <svg style={{ fill: 'none', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '16px' }}>
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 12.08248290464 L 30 8 L 22.92893219  3.91751709536 L 15.8578644 8 Z" />
      </svg>
    ),
    path: 'M 0 1.632993161856 L 2.828427124 3.265986326912 L 5.6568542488 1.632993161856 L 2.828427124 0 Z',
    position: 6.4,
    offset: 5,
    hasStroke: true,
  },
  {
    id: 16,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 30 7 M 30 12 L 20 7 L 30 2" />
      </svg>
    ),
    path: 'M 8 0 L 0 4 L 8 8', // multiply by 4/5
    position: 7.25,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 17,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 30 7 M 30 12 L 20 7 L 30 2 M 19.5 1.5 L 19.5 12.5" />
      </svg>
    ),
    path: 'M 8 0 L 0 4 L 8 8 M -0.6 -0.5 L -0.6 8.5', // multiply by 4/5
    position: 7.25,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 18,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 9.5 7 M 30 12 L 20 7 L 30 2 M 20 7 L 30 7 M 19.5 7 A 5,5 0 1 1 19.5,6.9996" />
      </svg>
    ),
    path: ['M 8 0 L 0 4 L 8 8', 'M -0.6 4 A 4,4 0 1 1 -0.6,3.9996 M 0 4 L 8 4'],
    position: 15.25,
    offset: 15,
    fill: '#fff',
    hasStroke: true,
  },
  {
    id: 19,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 30 7 M 25 14 L 25 0" />
      </svg>
    ),
    path: 'M 0 -0.5 L 0 8.5', // multiply by 4/5
    position: 8,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 20,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 30 7 M 25 14 L 25 0 M 20 14 L 20 0" />
      </svg>
    ),
    path: 'M 0 -0.5 L 0 8.5 M -4 -0.5 L -4 8.5', // multiply by 4/5
    position: 12,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 21,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
        }}
      >
        <path d="M 0 7 L 9.5 7 M 25 13 L 25 1 M 20 7 L 30 7 M 19.5 7 A 5,5 0 1 1 19.5,6.9996" />
      </svg>
    ),
    path: 'M 4 -0.5 L 4 8.5 M -0.6 4 A 4,4 0 1 1 -0.6,3.9996 M -0.5 4 L 8 4',
    position: 15.25,
    offset: 15,
    fill: '#fff',
    hasStroke: true,
  },
  {
    id: 22,
    icon: (
      <svg style={{ fill: 'none', stroke: '#787878', strokeWidth: '1.5px', width: '32px', height: '14px' }}>
        <path d="M 0 7 L 30 7 M 19 2 L 29 12" />
      </svg>
    ),
    path: 'M 0 0 L 8 8', // multiply by 4/5
    position: 8.25,
    offset: 0.1,
  },
];
export const ARROW_TAIL_TYPE = [
  {
    id: 1,
    icon: (
      <svg
        style={{
          width: '32px',
          height: '14px',
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7" />
      </svg>
    ),
    position: 0,
    offset: 0,
  },
  {
    id: 2,
    icon: (
      <svg
        style={{
          width: '32px',
          height: '14px',
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 20 7 L 20 12 L 30 7 L 20 2 L 20 7 Z" />
      </svg>
    ),
    path: 'M 0 0 L 4 2 L 0 4 Z',
    position: 4,
    offset: 4,
    isSolid: true,
  },
  {
    id: 3,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 20 7 L 20 12 L 30 7 L 20 2 L 20 7 Z" />
      </svg>
    ),
    path: 'M 0 0 L 4 2 L 0 4 Z',
    position: 4,
    offset: 4,
    hasStroke: true,
    isTriangle: true,
  },
  {
    id: 4,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 20 7 L 20 12 L 30 12 L 30 2 L 20 2 L 20 7 Z" />
      </svg>
    ),
    isSolid: true,
    path: 'M 0 0 L 4 0 L 4 4 L 0 4 Z',
    position: 4,
    offset: 4,
  },
  {
    id: 5,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 20 7 L 20 12 L 30 12 L 30 2 L 20 2 L 20 7 Z" />
      </svg>
    ),
    path: 'M 0 0 L 4 0 L 4 4 L 0 4 Z',
    position: 4,
    offset: 4,
    hasStroke: true,
    isRectangle: true,
  },
  {
    id: 6,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 19 2 L 29 12 M 29 2 L 19 12" />
      </svg>
    ),
    path: 'M 0 0 L 8 8 M 8 0 L 0 8', // multiply by 4/5
    position: 8.25,
    offset: 0.1,
  },
  {
    id: 7,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 20 12 L 30 7 L 20 2" />
      </svg>
    ),
    path: 'M 0 0 L 4 2 L 0 4',
    position: 4,
    offset: 0.5,
    fill: 'none',
    hasStroke: true,
    isTriangle: true,
  },
  {
    id: 8,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 20 7" />
        <path d="M 25.5,1.5 A 5.5,5.5 0 1 1 25.499,1.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 1 1.9996,0',
    position: 4,
    offset: 3.6,
    isSolid: true,
  },
  {
    id: 9,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 20 7" />
        <path d="M 25.5,1.5 A 5.5,5.5 0 1 1 25.499,1.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 1 1.9996,0',
    position: 4,
    hasStroke: true,
    offset: 3.9,
  },
  {
    id: 10,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 25 7" />
        <path d="M 30.5,1.5 A 5.5,5.5 0 1 0 30.5,12.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 0 2,4',
    position: 2,
    offset: 1.7,
    isSolid: true,
  },
  {
    id: 11,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 25 7" />
        <path d="M 30.5,1.5 A 5.5,5.5 0 1 0 30.5,12.5" />
      </svg>
    ),
    path: 'M 2,0 A 2,2 0 1 0 2,4',
    position: 1.8,
    offset: 1.7,
    hasStroke: true,
  },
  {
    id: 12,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '16px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 15.07106781 L 30 8 L 22.92893219 0.92893219 L 15.8578644 8 Z" />
      </svg>
    ),
    isSolid: true,
    path: 'M 2.82842712 0 L 5.65685425 2.82842712 L 2.82842712 5.65685425 L 0 2.82842712 Z',
    position: 5.65685425,
    offset: 5,
  },
  {
    id: 13,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '16px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 15.07106781 L 30 8 L 22.92893219 0.92893219 L 15.8578644 8 Z" />
      </svg>
    ),
    path: 'M 2.82842712 0 L 5.65685425 2.82842712 L 2.82842712 5.65685425 L 0 2.82842712 Z',
    position: 5.65685425,
    offset: 5,
    hasStroke: true,
  },
  {
    id: 14,
    icon: (
      <svg
        style={{
          fill: '#787878',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '16px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 12.08248290464 L 30 8 L 22.92893219  3.91751709536 L 15.8578644 8 Z" />
      </svg>
    ),
    isSolid: true,
    path: 'M 0 1.632993161856 L 2.828427124 3.265986326912 L 5.6568542488 1.632993161856 L 2.828427124 0 Z',
    position: 5.65685425,
    offset: 4.8,
  },
  {
    id: 15,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '16px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 8 L 15.8578644 8 L 22.92893219 12.08248290464 L 30 8 L 22.92893219  3.91751709536 L 15.8578644 8 Z" />
      </svg>
    ),
    path: 'M 0 1.632993161856 L 2.828427124 3.265986326912 L 5.6568542488 1.632993161856 L 2.828427124 0 Z',
    position: 6.4,
    offset: 5,
    hasStroke: true,
  },
  {
    id: 16,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 30 12 L 20 7 L 30 2" />
      </svg>
    ),
    path: 'M 8 0 L 0 4 L 8 8', // multiply by 4/5
    position: 7.25,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 17,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 30 12 L 20 7 L 30 2 M 19.5 1.5 L 19.5 12.5" />
      </svg>
    ),
    path: 'M 8 0 L 0 4 L 8 8 M -0.6 -0.5 L -0.6 8.5', // multiply by 4/5
    position: 7.25,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 18,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 9.5 7 M 30 12 L 20 7 L 30 2 M 20 7 L 30 7 M 19.5 7 A 5,5 0 1 1 19.5,6.9996" />
      </svg>
    ),
    path: ['M 8 0 L 0 4 L 8 8', 'M -0.6 4 A 4,4 0 1 1 -0.6,3.9996 M 0 4 L 8 4'],
    position: 15.25,
    offset: 15,
    fill: '#fff',
    hasStroke: true,
  },
  {
    id: 19,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 25 14 L 25 0" />
      </svg>
    ),
    path: 'M 0 -0.5 L 0 8.5', // multiply by 4/5
    position: 8,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 20,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 25 14 L 25 0 M 20 14 L 20 0" />
      </svg>
    ),
    path: 'M 0 -0.5 L 0 8.5 M -4 -0.5 L -4 8.5', // multiply by 4/5
    position: 12,
    offset: -0.9,
    fill: 'none',
    hasStroke: true,
  },
  {
    id: 21,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 9.5 7 M 25 13 L 25 1 M 20 7 L 30 7 M 19.5 7 A 5,5 0 1 1 19.5,6.9996" />
      </svg>
    ),
    path: 'M 4 -0.5 L 4 8.5 M -0.6 4 A 4,4 0 1 1 -0.6,3.9996 M -0.5 4 L 8 4',
    position: 15.25,
    offset: 15,
    fill: '#fff',
    hasStroke: true,
  },
  {
    id: 22,
    icon: (
      <svg
        style={{
          fill: 'none',
          stroke: '#787878',
          strokeWidth: '1.5px',
          width: '32px',
          height: '14px',
          transform: 'rotate(180deg)',
        }}
      >
        <path d="M 0 7 L 30 7 M 19 2 L 29 12" />
      </svg>
    ),
    path: 'M 0 0 L 8 8', // multiply by 4/5
    position: 8.25,
    offset: 0.1,
  },
];
export const LINE_SHAPE_TYPE = [
  {
    id: 1,
    icon: (
      <svg
        style={{
          width: '52px',
          height: '26px',
          fill: '#787878',
          stroke: '#787878',
          transform: 'scale(0.75)',
        }}
      >
        <path fill="none" stroke="#787878" d="M 1 17 L 1 22 L 6 22 L 6 17 Z" />
        <path fill="none" stroke="#787878" strokeWidth="2px" d="M 6 19.5 L 26 19.5 L 26 7.5 L 46 7.5" />
        <path fill="none" stroke="#787878" d="M 46 5 L 46 10 L 51 10 L 51 5 Z" />
      </svg>
    ),
    shapeType: 'Sharp',
  },
  {
    id: 2,
    icon: (
      <svg
        style={{
          width: '52px',
          height: '26px',
          fill: '#787878',
          stroke: '#787878',
          transform: 'scale(0.75)',
        }}
      >
        <path fill="none" stroke="#787878" d="M 1 17 L 1 22 L 6 22 L 6 17 Z" />
        <path
          fill="none"
          stroke="#787878"
          strokeWidth="2px"
          d="M 6 19.5 L 23 19.5 Q 26 19.5, 26 16.5 L 26 10.5 Q 26 7.5, 29 7.5 L 46 7.5"
        />
        <path fill="none" stroke="#787878" d="M 46 5 L 46 10 L 51 10 L 51 5 Z" />
      </svg>
    ),
    shapeType: 'Rounded',
  },
  {
    id: 3,
    icon: (
      <svg
        style={{
          width: '52px',
          height: '23px',
          fill: '#787878',
          stroke: '#787878',
          transform: 'scale(0.75)',
        }}
      >
        <path fill="none" stroke="#787878" d="M 1 17 L 1 22 L 6 22 L 6 17 Z" />
        <path fill="none" stroke="#787878" strokeWidth="2px" d="M 3.5 17 A 25 20 0 0 1 46 8" />
        <path fill="none" stroke="#787878" d="M 44.24 9.76 L 47.76 6.24 L 51.31 9.76 L 47.76 13.31 Z" />
      </svg>
    ),
    shapeType: 'Curved',
  },
  {
    id: 4,
    icon: (
      <svg
        style={{
          width: '54px',
          height: '22px',
          fill: '#787878',
          stroke: '#787878',
          transform: 'scale(0.75) rotate(-20deg)',
        }}
      >
        <path fill="none" stroke="#787878" d="M 3 9 L 3 14 L 8 14 L 8 9 Z" />
        <path fill="none" stroke="#787878" strokeWidth="2px" d="M 8 11.5 L 48 11.5" />
        <path fill="none" stroke="#787878" d="M 48 9 L 48 14 L 53 14 L 53 9 Z" />
      </svg>
    ),
    shapeType: 'Straight',
  },
];
const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE', 'OS/2', 'Pocket PC'];
export const isWindow = () => {
  const { platform } = window.navigator;
  return windowsPlatforms.includes(platform);
};
export const EDIT_MENU = {
  fontWeight: {
    icon: <BoldOutlined style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: `Bold (${isWindow() ? 'Ctrl' : '⌘'} + B)`,
    type: 'button',
  },
  fontStyle: {
    icon: <ItalicOutlined style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: `Italic (${isWindow() ? 'Ctrl' : '⌘'} + I)`,
    type: 'button',
  },
  underline: {
    icon: <UnderlineOutlined style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: `Underline (${isWindow() ? 'Ctrl' : '⌘'} + U)`,
    type: 'button',
  },
  linethrough: {
    icon: <FontAwesomeIcon icon={faStrikethrough} style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: `Strikethrough (${isWindow() ? 'Ctrl' : '⌘'} + S)`,
    type: 'button',
  },
  superscript: {
    icon: <FontAwesomeIcon icon={faSuperscript} style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: 'Superscript',
    type: 'button',
  },
  subscript: {
    icon: <FontAwesomeIcon icon={faSubscript} style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: 'Subscript',
    type: 'button',
  },
  fill: {
    icon: null,
    tooltipLabel: 'Text Color',
    type: 'input',
  },
  background: {
    icon: null,
    tooltipLabel: 'Background Color',
    type: 'color',
  },
  unorderList: {
    icon: <FontAwesomeIcon icon={faListUl} style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: 'Unordered list',
    type: 'button',
  },
  orderList: {
    icon: <FontAwesomeIcon icon={faListOl} style={{ fontWeight: 'bold', fontSize: '13px' }} />,
    tooltipLabel: 'Ordered list',
    type: 'button',
  },
};
export const EVENT_TYPE = {
  key_code: 0,
  new_component: 1,
  new_text_component: 2,
  paste_here: 4,
  un_group: 5,
};
export const CONTEXT_MENU_ITEM = {
  copy: {
    text: 'Copy',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + C`,
    icon: '',
    keyCode: KEYS_CODE.C,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  cut: {
    text: 'Cut',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + X`,
    icon: '',
    keyCode: KEYS_CODE.X,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  paste: {
    text: 'Paste',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + V`,
    icon: '',
    keyCode: KEYS_CODE.V,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  pasteHere: {
    text: 'Paste Here',
    shortcut: '',
    icon: '',
    keyCode: null,
    ctrlKey: null,
    type: EVENT_TYPE.paste_here,
  },

  undo: {
    text: 'Undo',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + Z`,
    tooltip: `Undo (${isWindow() ? 'Ctrl' : '⌘'} + Z)`,
    icon: '',
    divider: false,
    keyCode: KEYS_CODE.Z,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  redo: {
    text: 'Redo',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + Y`,
    tooltip: `Redo (${isWindow() ? 'Ctrl' : '⌘'} + Y)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.Y,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  resetView: {
    text: 'Reload view',
    shortcut: `${isWindow() ? 'Alt' : '⌥'} + R`,
    tooltip: `Reload view (${isWindow() ? 'Alt' : '⌥'} + R)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.R,
    ctrlKey: false,
    altKey: true,
    type: EVENT_TYPE.key_code,
  },
  selectAll: {
    text: 'Select All',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + A`,
    icon: '',
    keyCode: KEYS_CODE.A,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  duplicate: {
    text: 'Duplicate',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + D`,
    icon: '',
    keyCode: KEYS_CODE.D,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  delete: {
    text: 'Delete',
    shortcut: `${isWindow() ? 'DEL' : '⌫'}`,
    icon: '',
    keyCode: 46,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  createComponent: {
    text: 'Group',
    shortcut: '',
    icon: '',
    keyCode: null,
    ctrlKey: null,
    type: EVENT_TYPE.new_component,
  },
  ungroup: {
    text: 'Ungroup',
    shortcut: '',
    icon: '',
    keyCode: null,
    ctrlKey: null,
    type: EVENT_TYPE.un_group,
  },
};

export const CONTEXT_MAIN_HEADER_ITEM = {
  undo: {
    text: 'Undo',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + Z`,
    tooltip: `Undo (${isWindow() ? 'Ctrl' : '⌘'} + Z)`,
    icon: '',
    divider: false,
    keyCode: KEYS_CODE.Z,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  redo: {
    text: 'Redo',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + Y`,
    tooltip: `Redo (${isWindow() ? 'Ctrl' : '⌘'} + Y)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.Y,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  freeDrawing: {
    text: 'Free Drawing',
    shortcut: `${isWindow() ? 'Alt' : '⌥'} + D`,
    tooltip: `Free Drawing (${isWindow() ? 'Alt' : '⌥'} + D)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.D,
    ctrlKey: false,
    altKey: true,
    type: EVENT_TYPE.key_code,
  },
  saveDrawing: {
    text: 'Save Drawing',
    shortcut: `${isWindow() ? 'Alt' : '⌥'} + D`,
    tooltip: `Save Drawing (${isWindow() ? 'Alt' : '⌥'} + D)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.D,
    ctrlKey: false,
    altKey: true,
    type: EVENT_TYPE.key_code,
  },
  exportPng: {
    text: 'Export PNG',
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + E`,
    tooltip: `Export PNG (${isWindow() ? 'Ctrl' : '⌘'} + E)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.E,
    ctrlKey: true,
    type: EVENT_TYPE.key_code,
  },
  resetView: {
    text: 'Reload view',
    shortcut: `${isWindow() ? 'Alt' : '⌥'} + R`,
    tooltip: `Reload view (${isWindow() ? 'Alt' : '⌥'} + R)`,
    icon: '',
    divider: true,
    keyCode: KEYS_CODE.R,
    ctrlKey: false,
    altKey: true,
    type: EVENT_TYPE.key_code,
  },
};

export const LAYER_ACTIONS = [
  {
    title: 'Send backwards',
    action: 'sendBackwards',
    icon: images.BACKWARD,
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + ↓`,
    ctrlKey: true,
    keyCode: KEYS_CODE.DOWN,
  },
  {
    title: 'Send to back',
    action: 'sendToBack',
    icon: images.BACK,
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + ${isWindow() ? 'Shift' : '⇧'} + ↓`,
    ctrlKey: true,
    shiftKey: true,
    keyCode: KEYS_CODE.DOWN,
  },
  {
    title: 'Brings forwards',
    action: 'bringForward',
    icon: images.FORWARD,
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + ↑`,
    ctrlKey: true,
    keyCode: KEYS_CODE.UP,
  },
  {
    title: 'Bring to front',
    action: 'bringToFront',
    icon: images.FRONT,
    shortcut: `${isWindow() ? 'Ctrl' : '⌘'} + ${isWindow() ? 'Shift' : '⇧'} + ↑`,
    ctrlKey: true,
    shiftKey: true,
    keyCode: KEYS_CODE.DOWN,
  },
];
export const TRANSFORM_TOOLTIP = {
  x: 'Left',
  y: 'Top',
  width: 'Width',
  height: 'Height',
  scaleX: 'Scale Horizontal',
  scaleY: 'Scale Vertical',
};
export const USER_COMPONENT_CATEGORY_ID = 9999;
export const USER_COMPONENT_CATEGORY_NAME = 'Saved Component';
export const USER_COMPONENT_CATEGORY_DEFAULT = {
  id: USER_COMPONENT_CATEGORY_ID,
  name: USER_COMPONENT_CATEGORY_NAME,
};
export const ZOOM_RAITO = 10;
export const ZOOM_DEFAULT = 100;
export const PAGES = {
  homePage: 0,
  notificationPage: 1,
};
export const OBJECT_STATUS = {
  active: 1,
  inTrash: 0,
};
export const SAVE_STATUS = {
  saving: 0,
  saved: 1,
  saveFailed: 2,
};
export const GET_ALL_OPTION = '-1';

export const VIEWPORT_TRANSFORM_DEFAULT = [1, 0, 0, 1, 0, 0];

export const MAX_UPLOAD_IMAGE_FILE_SIZE = {
  MB: 2,
};

export const USER_COMPONENT = {
  ELEMENT: 'ELEMENT',
  IMAGE: 'IMAGE',
};

export const CANVAS_ACTION = {
  UNDO: 'on-undo',
  REDO: 'on-redo',
  COPY: 'on-copy',
  COPY_SUCCESS: 'on-copy-success',
  PASTE: 'on-paste',
  RESET_VIEW: 'on-reset-view',
  SELECTED_OBJECT: 'on-object-select',
  EXPORT_PNG: 'export-png',
  DRAWING: 'on-drawing-click',
};

export const URL_LIMIT_LENGTH = 2048;
export const IMAGE_ITEM_SIZE = {
  width: 150,
  height: 150,
};
export const IMAGE_THUMBNAIL_SIZE = {
  width: 500,
  height: 500,
};
export const COMPONENT_ITEM_CONTAINER = {
  width: 100,
  height: 100,
};

export const MAXIMUM_NUMBER_IMAGES = 50;
export const MAXIMUM_NAME_LENGTH = 50;

export const MENU_LEFT = {
  PAGE: 'pages',
  ELEMENS: 'elements',
  DIAGRAMS: 'diagrams',
  ICONS: 'icons',
  IMAGES: 'images',
  TRASH: 'trash',
};

export const PAGE_SETTING_DEFAULT = {
  w: 1600,
  h: 1200,
  t: 0,
  l: 0,
  color: '#ffffff',
  isLocked: false,
  syncMode: AUTO,
  stroke: '#e0e0e0',
  gridSize: 10,
  showGrid: true,
  alignment: true,
};

export const MINIMUM_CUSTOM_PAGESIZE = 200;
export const MINIMUM_PAGESIZE = 500;
export const MAXIMUM_PAGESIZE = 10000;
export const TRANSPARENT_COLOR = '#f0f0f0';
export const DEFAULT_MINIMUM_POINT = 100000000;

export const MULTIPLE = 'multiple';
export const TRANSPARENT = 'transparent';

export const EDGE_NAME_PREFIX = 'EDGE_BACKGROUND';

export const BACKGROUND_EDGE_NAME = {
  bottom: `${EDGE_NAME_PREFIX}_BOTTOM`,
  left: `${EDGE_NAME_PREFIX}_LEFT`,
  right: `${EDGE_NAME_PREFIX}_RIGHT`,
  top: `${EDGE_NAME_PREFIX}_TOP`,
};

export const BACKGROUND_EDGE_OPTIONS = {
  strokeWidth: 20,
  stroke: 'transparent',
  hasControls: false,
  hasBorders: false,
  selectable: false,
};
export const outSideNode = ['header', 'outside-tree', 'list', 'mo__map-view'];

export const LABEL_MONTH = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const LABEL_DATE = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const FROM_PUBLISH = 'publish';

export const PAGE_OPTION = [
  {
    value: {
      // this option always in top of array
      label: 'Auto scale (default)',
      isLocked: false,
      w: 500,
      h: 500,
    },
  },
  {
    value: {
      label: 'A4 (vertical)',
      isLocked: true,
      w: 595,
      h: 842,
    },
  },
  {
    value: {
      label: 'A4 (horizontal)',
      isLocked: true,
      w: 842,
      h: 595,
    },
  },
  {
    value: {
      label: 'Android',
      isLocked: true,
      w: 360,
      h: 640,
    },
  },
  {
    value: {
      label: 'Android Tablet',
      isLocked: true,
      w: 800,
      h: 1280,
    },
  },
  {
    value: {
      label: 'Android Large',
      isLocked: true,
      w: 393,
      h: 851,
    },
  },
  {
    value: {
      label: 'Web Common',
      isLocked: true,
      w: 1366,
      h: 768,
    },
  },
  {
    value: {
      label: 'Web Small',
      isLocked: true,
      w: 1280,
      h: 800,
    },
  },
  {
    value: {
      label: 'Web Medium',
      isLocked: true,
      w: 1440,
      h: 900,
    },
  },
  {
    value: {
      label: 'Web Large',
      isLocked: true,
      w: 1920,
      h: 1080,
    },
  },
  {
    value: {
      label: 'Whiteboard',
      isLocked: true,
      w: 2000,
      h: 2000,
    },
  },
  {
    value: {
      label: 'iPad 10.2in',
      isLocked: true,
      w: 810,
      h: 1080,
    },
  },
  {
    value: {
      label: 'iPad Pro 11in',
      isLocked: true,
      w: 834,
      h: 1194,
    },
  },
  {
    value: {
      label: 'iPad Pro 12.9in',
      isLocked: true,
      w: 1024,
      h: 1366,
    },
  },
  {
    value: {
      label: 'iPad Mini',
      isLocked: true,
      w: 768,
      h: 1024,
    },
  },

  {
    value: {
      label: 'Surface Pro 8/X',
      isLocked: true,
      w: 1440,
      h: 960,
    },
  },
  {
    value: {
      label: 'iPhone 12/13',
      isLocked: true,
      w: 390,
      h: 844,
    },
  },
  {
    value: {
      label: 'iPhone 12/13 Pro Max',
      isLocked: true,
      w: 428,
      h: 926,
    },
  },
  {
    value: {
      label: 'iPhone X/XS/13 Mini',
      isLocked: true,
      w: 375,
      h: 812,
    },
  },
  {
    value: {
      label: 'iPhone 6/7/8/SE',
      isLocked: true,
      w: 375,
      h: 667,
    },
  },

  {
    value: {
      label: 'Instagram Post',
      isLocked: true,
      w: 1080,
      h: 1080,
    },
  },
  {
    value: {
      label: 'Twitter Post',
      isLocked: true,
      w: 1024,
      h: 512,
    },
  },
  {
    value: {
      label: 'Facebook Post',
      isLocked: true,
      w: 1200,
      h: 630,
    },
  },
  {
    value: {
      label: 'Letter',
      isLocked: true,
      w: 576,
      h: 793,
    },
  },
  {
    value: {
      label: 'Legal',
      isLocked: true,
      w: 576,
      h: 1009,
    },
  },
  {
    value: {
      label: 'High Definition (HD)',
      isLocked: true,
      w: 1366,
      h: 768,
    },
  },
  {
    value: {
      label: 'High Definition Plus (HD+)',
      isLocked: true,
      w: 1600,
      h: 900,
    },
  },
  {
    value: {
      label: 'Full High Definition (FHD)',
      isLocked: true,
      w: 1920,
      h: 1200,
    },
  },
  {
    value: {
      label: 'Quad High Definition (QHD/2k)',
      isLocked: true,
      w: 2560,
      h: 1440,
    },
  },
  {
    value: {
      label: 'Wide Quad High Definition (WQHD)',
      isLocked: true,
      w: 3440,
      h: 1440,
    },
  },
  {
    value: {
      label: ' Ultra High Definition (UHD/4k)',
      isLocked: true,
      w: 3840,
      h: 2160,
    },
  },
];

export const ALIGNMENT_MENU = {
  left: {
    icon: <img src={images.ALIGN_OBJECTS} style={{ height: '20px' }}></img>,
    tooltipLabel: 'Align left',
    type: 'button',
    img: images.ALIGN_OBJECTS,
  },
  center: {
    icon: <img src={images.ALIGN_CENTER} style={{ height: '20px' }}></img>,
    tooltipLabel: 'Align center',
    type: 'button',
    img: images.ALIGN_CENTER,
  },
  right: {
    icon: <img src={images.ALIGN_OBJECTS} style={{ height: '20px', transform: 'scaleX(-1)' }}></img>,
    tooltipLabel: 'Align right',
    type: 'button',
    img: images.ALIGN_OBJECTS,
  },
  top: {
    icon: <img src={images.ALIGN_OBJECTS} style={{ height: '20px', transform: 'rotate(90deg) scaleY(-1)' }}></img>,
    tooltipLabel: 'Align top',
    type: 'button',
    img: images.ALIGN_OBJECTS,
  },
  middle: {
    icon: <img src={images.ALIGN_CENTER} style={{ height: '20px', transform: 'rotate(90deg)' }}></img>,
    tooltipLabel: 'Align middle',
    type: 'button',
    img: images.ALIGN_CENTER,
  },
  bottom: {
    icon: <img src={images.ALIGN_OBJECTS} style={{ height: '20px', transform: 'rotate(-90deg)' }}></img>,
    tooltipLabel: 'Align bottom',
    type: 'button',
    img: images.ALIGN_OBJECTS,
  },
};

export const STICKY_COLOR_MENU = {
  light: ['#FCFFBF', '#FFE3E1', '#E3DFFD', '#C5DFF8', '#D5FFD0', '#FFDCA9', '#DFD3C3', '#F6F6F6', '#CDD0CB'],
  dark: ['#FFF46E', '#FF9494', '#BEADFA', '#78C1F3', '#79AC78', '#FAAB78', '#AD8B73', '#DDDDDD', '#A6A9B6'],
};

export const MOUSE_BUTTON = {
  left: 1,
  middle: 2,
  right: 3,
};

export const SUPPORT_SET_AS_TEXT_COMPONENT = [
  'Donut',
  'Rectangle',
  'Star',
  'Hexagon',
  'Pentagon',
  'Eclipse',
  'Square',
  'Triangle',
  'Circle',
];

export const BUS_EVENTS = {
  ADD_CUSTOM_COMPONENT: 'on-add-custom-component',
  ADD_COMPONENT: 'on-add-component',
  ADD_COL_ITEM: 'on-add-col-item',
  ADD_NEW_PROJECT: 'add-new-project',
  ALIGN_TEXT: 'on-align-text',
  ALIGN_GROUP: 'on-align-group',
  CHANGE_BACKGROUND: 'on-change-background',
  CHANGE_EDIT_TEXT: 'on-change-edit-text',
  CHANGE_FLIP: 'on-change-flip',
  CHANGE_LAYER: 'on-change-layer',
  CHANGE_PAGE_AND_FOLDER_NAME: 'on-change-page-and-folder-name',
  CHANGE_TRANSFORM: 'on-change-transform',
  CLEAR_ADD_OBJECT_TIME_OUT: 'clear-add-object-time-out',
  CLEAR_BACKUP_FILES_SELECTION: 'on-clear-backup-files-selection',
  CLEAR_PAGE_LIST_SELECTION: 'on-clear-page-list-selection',
  CLOSE_DRAWING: 'on-close-drawing',
  CLOSE_REVISION_HISTORY: 'close-revision-history',
  CLOSE_VISUAL_LIST: 'on-close-visual-list',
  COLUMN_ADDED: 'on-column-added',
  CREATE_PAGE: 'on-create-page',
  CREATE_PROJECT: 'on-create-project',
  DELETE_COL: 'on-delete-col',
  DELETE_COL_ITEM: 'on-delete-col-item',
  DRAWING: 'on-drawing',
  DUPLICATE_PAGE: 'on-duplicate-page',
  EDIT_COL: 'on-edit-col',
  EDIT_PROJECT: 'edit-project',
  EDIT_VISUAL_LIST_HIERARCHY: 'on-edit-visual-list-hierarchy',
  EXPORT_IMAGE_TO_PNG: 'on-export-image-to-png',
  FOCUS_SEARCH_ELEMENT: 'on-focus-search-element',
  FILTER_TEMPLATES: 'on-filter-templates',
  HANDLE_LAYER_CONTEXT: 'on-handle-layer-context',
  HANDLE_MENU_CONTEXT: 'on-handle-menu-context',
  HOVER_ON_COMPONENT: 'on-hover-on-component',
  LOAD_CANVAS_CONTENT: 'load-canvas-content',
  MOVE_BULK_TO_TRASH: 'on-move-bulk-to-trash',
  OPEN_EDIT_COMPONENT_MODAL: 'on-open-edit-component-modal',
  OPEN_DRAWING: 'on-open-drawing',
  OPEN_PROJECT: 'on-open-project',
  REDO: 'on-redo',
  REGROUP: 'on-regroup',
  RESET_TREE_DATA: 'on-reset-tree-data',
  RESET_VIEW: 'on-reset-view',
  SAVE_PAGE: 'on-save-page',
  SAVE_CANVAS_STATE: 'on-save-canvas-state',
  SAVE_STATE_AND_PROGRESS: 'on-save-state-and-progress',
  SAVE_STATE_IMMEDIATELY: 'on-save-state-immediately',
  SEARCH_COMPONENT: 'on-search-component',
  SEARCH_PROJECT: 'on-search-project',
  SET_CONTEXT_STATE: 'on-set-context-state',
  SET_OLD_TREE: 'on-set-old-tree',
  SET_STATE_TEXT_STYLE: 'on-set-state-text-style',
  SET_PROJECT_CREATED: 'on-set-project-created',
  SET_MENU_KEY: 'on-set-menu-key',
  SET_TEXT_COMPONENT: 'on-set-text-component',
  SORT_PROJECT: 'on-sort-project',
  TOGGLE_SHARE_PROJECT_MODAL: 'on-toggle-share-project-modal',
  TOGGLE_CHART_SETTINGS: 'on-toggle-chart-settings',
  UNDO: 'on-undo',
  UPDATE_CURRENT_MOUSE_POSITION: 'update-current-point-position',
  UPDATE_VIEW_PORT: 'on-update-view-port',
  UPDATE_ZOOM_SLIDER: 'on-update-zoom-slider',
  UPDATE_POSITION_MENU_EDITOR: 'on-update-position-menu-editor',
  UPDATE_HTML_COMPONENT: 'on-update-html-component',
  UPDATE_CHART_OBJECT: 'on-update-chart-object',
  UPDATE_COMMON_SETTING: 'on-update-common-setting',
  ZOOM: 'on-zoom',
};

export const initTextStyle = {
  fontWeight: 'normal',
  fontStyle: 'normal',
  underline: false,
  linethrough: false,
  superscript: false,
  subscript: false,
  fontSize: 12,
  fontFamily: 'Helvetica',
  textAlign: 'left',
  textBackgroundColor: '#fff',
  fill: '#000',
};

export const STATUS_IMAGE = {
  LOADING: 'LOADING',
  ERR: 'ERR',
  SUCCESS: 'SUCCESS',
};

export const SHAPE_SUGGESTION_SIZE = {
  width: 140,
  height: 100,
};

export const SHAPE_SUGGESTION = {
  flowchart: {
    title: 'Flowchart',
  },
  shapes: {
    title: 'Shapes',
  },
};

export const REVISION_LOADING_ITEMS = [
  {
    loading: true,
  },
  {
    loading: true,
  },
];

export const OFFSET_TEXT_IN_DIAGRAM = 20;

export const RGB = 'rgb';

export const CHART_MENU = [
  {
    title: 'Bar',
    image: images.BAR_CHART,
    options: {
      type: 'bar',
    },
  },
  {
    title: 'Stacked bar',
    image: images.BAR_STACKED_CHART,
    options: {
      type: 'bar',
      stack: true,
    },
  },
  {
    title: 'Column',
    image: images.COLUMN_CHART,
    options: {
      type: 'bar',
    },
  },
  {
    title: 'Stacked column',
    image: images.COLUMN_STACKED_CHART,
    options: {
      type: 'bar',
      stack: true,
    },
  },
  {
    title: 'Area',
    image: images.AREA_CHART,
    options: {
      type: 'line',
    },
  },
  {
    title: 'Stacked area',
    image: images.AREA_STACKED_CHART,
    options: {
      type: 'line',
      stack: true,
    },
  },
  {
    title: 'Line',
    image: images.LINE_CHART,
    options: {
      type: 'line',
    },
  },
  {
    title: 'Pie',
    image: images.PIE_CHART,
    options: {
      type: 'pie',
    },
  },
  {
    title: 'Polar',
    image: images.POLAR_CHART,
    options: {
      type: 'polarArea',
    },
  },
  {
    title: 'Radar',
    image: images.RADAR_CHART,
    options: {
      type: 'radar',
    },
  },
];

export const COLOR_PALETTES = [
  ['#FF847C', '#E84A5F', '#2A363B', '#F9C5BA', '#323232', '#FCEADE', '#648381', '#C5D1EB'],
  ['#3C1642', '#086375', '#1DD3B0', '#FFD34E', '#F27D42', '#C75146', '#AAAEB0', '#7E6464'],
  ['#1C1718', '#57385C', '#8A6DAB', '#D0BDF4', '#F0DDEB', '#F4F3F6', '#E7EFF2', '#ACD8AA'],
  ['#1F271B', '#254E58', '#F2F4F3', '#FFBE40', '#F78259', '#EE6352', '#8CA7A1', '#F0F8F7'],
  ['#392F5A', '#613E6C', '#FF7D1C', '#F0C143', '#D9EA5B', '#7F9E32', '#F3D9BC', '#E3B8C2'],
  ['#13505B', '#1A6C6E', '#FFD700', '#FFAA00', '#FF8C00', '#FF6300', '#FF3000', '#E82323'],
  ['#DD3C4B', '#F6F4D2', '#0D324D', '#2E86AB', '#86C1B9', '#E0E7C8', '#F8F6F4', '#B5838D'],
  ['#440047', '#2E004B', '#6A0572', '#A6B1E1', '#FFDD2D', '#FF512F', '#DD2476', '#8F2D56'],
  ['#E4572E', '#17BEBB', '#FFC914', '#2E282A', '#76B041', '#B3DD39', '#FF83A8', '#2E282A'],
  ['#46351D', '#6B4423', '#F4ECD8', '#BBCFB9', '#76ADAB', '#D9C8A9', '#8A473E', '#D90000'],
  ['#AAABD3', '#FBFFD3', '#F8D7DA', '#FEB596', '#ED8B8C', '#DBF4A7', '#FFA775', '#FF9C5B'],
  ['#0D0630', '#18314F', '#F7F9F9', '#BB4430', '#A2A7A9', '#2F6690', '#E74C3C', '#FFF7F8'],
  ['#393E46', '#00ADB5', '#F8B500', '#FC3C3C', '#D62828', '#8F1D21', '#F5F5F5', '#A1CDA8'],
  ['#05668D', '#028090', '#00A896', '#02C39A', '#F0F3BD', '#FF6F59', '#CC2936', '#53599A'],
  ['#F6A9A9', '#DD6E42', '#661B39', '#1D1A1D', '#B9C5D4', '#F3F3F3', '#FFD6BA', '#FFAC9A'],
  ['#E4572E', '#FF824A', '#FFBC6B', '#FFE87C', '#C2F970', '#4BB543', '#0D98BA', '#3D84A8'],
  ['#C46BAE', '#FFC2E2', '#FFDAC1', '#FF9D6C', '#FF5470', '#CA455F', '#C5D8D1', '#8E5572'],
  ['#0A2463', '#1E88A8', '#FFE33F', '#FFA900', '#FF7D00', '#FF4200', '#B21F35', '#5E1C52'],
  ['#231942', '#5E548E', '#9F86C0', '#C6AAD0', '#E8DDB5', '#EAC6AC', '#BCA58D', '#745C4B'],
  ['#3F4053', '#7B1E7A', '#FAA916', '#FF5420', '#D81E5B', '#4E4D4A', '#FF8100', '#008DB8'],
];

export const HELP_MENU = {
  confluence: [
    { label: 'User guide', url: 'https://docs.devsamurai.com/mocky/use-guide' },
    { label: 'Blogs', url: 'https://mockyapp.com/blog/' },
    { label: 'Videos', url: 'https://www.youtube.com/embed/EVj1Vsu3FDE' },
    { label: 'Contact support', url: 'https://devsamurai.atlassian.net/servicedesk/customer/portal/12' },
    {
      label: 'Leave a review',
      url:
        'https://marketplace.atlassian.com/apps/1225654/draw-wireframes-mockup-prototype-diagrams-for-confluence?hosting=cloud&tab=reviews',
    },
  ],
  jira: [
    { label: 'User guide', url: 'https://docs.devsamurai.com/mocky/use-guide' },
    { label: 'Blogs', url: 'https://mockyapp.com/blog/' },
    { label: 'Videos', url: 'https://www.youtube.com/embed/EVj1Vsu3FDE' },
    { label: 'Contact support', url: 'https://devsamurai.atlassian.net/servicedesk/customer/portal/15' },
    {
      label: 'Leave a review',
      url:
        'https://marketplace.atlassian.com/apps/1226280/draw-ui-wireframes-mockup-prototype-diagrams-for-jira?hosting=cloud&tab=reviews',
    },
  ],
};

export const CANVAS_BACKGROUND_COLOR = 'transparent';
